const styles = {
  valueContainer: () => ({
    paddingLeft: 0,
    display: 'flex',
    flexWrap: 'wrap',
    minHeight: '45px',
  }),
  singleValue: (base, state) => {
    const fontSize = state.isMobile ? 10 : 12;
    return {
      paddingLeft: 0,
      fontSize: fontSize,
      color: "#1a1819",
      maxHeight: '45px',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
    }
  },
  multiValue: (base, state) => {
    return {
      display: 'flex',
      alignItems: 'center',
      color: '#1a1819',
      height: '22px',
    }
  },
  multiValueLabel: (base, state) => {
    const fontSize = state.isMobile ? 10 : 12;
    return {
      fontSize: fontSize,
      lineHeight: '22px',
    }
  },
  multiValueRemove: () => {
    return {
      width: '22px',
      height: '22px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }
  },
  input: (base, state) => {
    return {
      height: '22px',
      display: 'flex',
      alignItems: 'center',
      color: '#1a1819',
    }
  },
  placeholder: (base, state) => {
    const { menuIsOpen } = state.selectProps;
    const fontSize = state.isMobile ? 10 : 12;
    return {
      marginLeft: 0,
      fontSize: fontSize,
      opacity: 0,
      textTransform: "uppercase",
      fontWeight: 800,
    }
  },
  indicatorsContainer: () => ({
    width: 30,
    height: 30,
  }),
  dropdownIndicator: () => ({
    padding: 0,
    fontSize: 30,
    lineHeight: 1,
    height: 30,
    fill: '#a0adb8',
  }),
  menu: (base, state) => {
    return {
      ...base,
      borderRadius: '0px',
      marginTop: '0px',
      marginBottom: '0px',
      animationTimingFunction: 'ease',
      overflow: 'hidden',
      boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 0.1)',
      zIndex: 3,
    }
  },
  menuList: (base, state) => ({
    ...base,
    paddingBottom: '30px',
    paddingTop: '30px',
    fontWeight: 800,
    fontSize: 12,
    lineHeight: '20px',
    textTransform: 'uppercase',
  }),
  option: (base, state) => {
    const bgDefault = 'transparent';
    const bgDisabled = state.isDisabled ? '#a0adb8' : bgDefault;
    const bgSelected = state.isSelected ? '#ecf3fe' : bgDisabled;
    const bgFocused = state.isFocused ? '#4888f8' : bgDefault;
    // const bgFocused = state.isFocused ? '#4888f8' : bgSelected;

    const colorDefault = state.data.hasParentId ? '#5d656b' : '#a0adb8';
    // const colorDisabled = state.isDisabled ? '#fff' : colorDefault;
    // const colorSelected = state.isSelected ? '#a0adb8' : colorDisabled;
    const colorFocused = state.isFocused ? '#fff' : colorDefault;
    // const colorFocused = state.isFocused ? '#fff' : colorSelected;

    const paddingDefault = state?.data?.hasParentId ? '30px 15px 30px 50px' : '15px 30px';

    const defaultCursor = state.isDisabled ? 'default' : 'pointer';
    return {
      // color: '#a0adb8',
      padding: paddingDefault,
      margin: '0 0',
      minHeight: '60px',
      display: 'flex',
      alignItems: 'center',
      // backgroundColor: bgDefault,
      // backgroundColor: bgDisabled,
      backgroundColor: bgSelected,
      backgroundColor: bgFocused,

      // justifyContent: justifyDefault,
      color: colorDefault,
      // color: colorDisabled,
      // color: colorSelected,
      color: colorFocused,
      cursor: defaultCursor,
      '&:not(:last-child)': {

      }
    }
  },
  container: (base, state) => {
    return {
    }
  },
  control: (base, state) => {
    return {
      ...base,
      minHeight: 45,
      borderTop: 0,
      borderLeft: 0,
      borderRadius: 0,
      borderRight: 0,
      boxShadow: 'none',
      fontWeight: '800',
      color: '#a0adb8',
      flexWrap: 'nowrap',
      backgroundColor: "transparent",

      borderColor: state.selectProps && state.selectProps.hasError ? "#df503f" : state.isFocused ? "#4888f8" : "#a0adb8",
      '&:hover': { borderColor: '#4888f8' },

      opacity: state.isDisabled ? 0.5 : 1,
    }
  },
}


export default styles;
